/**
 * Presentación de ausencias (008 · T076). Solo formatea lo que devuelve la API: fechas `LocalDate`
 * como texto local (`dd/mm/aaaa`) y horas `HH:mm` en 24 h, sin convertir zonas.
 */
import type { Absence } from '@fermin/contracts';

import { t } from '../../i18n';
import { formatLocalDay, timeRange } from '../schedules/format';

/** "05/10/2026 al 16/10/2026", "08/10/2026" o "13/10/2026 · 08:00–10:00". */
export function absenceRangeLabel(
  absence: Pick<Absence, 'start_day' | 'end_day' | 'start_time' | 'end_time' | 'partial'>,
): string {
  if (absence.partial && absence.start_time && absence.end_time) {
    return t('absences.format.hours', {
      day: formatLocalDay(absence.start_day),
      range: timeRange(absence.start_time, absence.end_time),
    });
  }
  if (absence.start_day === absence.end_day) {
    return formatLocalDay(absence.start_day);
  }
  return t('absences.format.range', {
    from: formatLocalDay(absence.start_day),
    to: formatLocalDay(absence.end_day),
  });
}
